<div class="table-header-container" *ngIf="isDesktop">
  <app-table-header
    [hidden]="!customersMetrics || !customersMetrics.length"
    [dataColumns]="[
      {
        size: this.columnSizes[0],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' + HeaderFields.customer
          | translate,
        sortField: HeaderFields.customer,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'account-activity-customer-information',
      },
      {
        size: this.columnSizes[1],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.creditStatus | translate,
        sortField: HeaderFields.creditStatus,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'account-activity-credit-status',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[2],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' + HeaderFields.seller
          | translate,
        sortField: HeaderFields.seller,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'account-activity-seller',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[3],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.openInvoices | translate,
        sortField: HeaderFields.openInvoices,
        dataCyName: 'account-activity-open-invoices',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[4],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.unusedCredits | translate,
        sortField: HeaderFields.unusedCredits,
        dataCyName: 'account-activity-unused-credits',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[5],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.paymentMethod | translate,
        sortField: HeaderFields.paymentMethod,
        sortDirectionByDefault: SortDirection.ASC,
        dataCyName: 'account-activity-payment-method',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[6],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.percentageCurrent | translate,
        sortField: HeaderFields.percentageCurrent,
        dataCyName: 'account-activity-current-percentage',
      },

      {
        size: this.columnSizes[7],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.accountBalance | translate,
        sortField: HeaderFields.accountBalance,
        dataCyName: 'account-activity-account-balance',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[8],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.currentBalance | translate,
        sortField: HeaderFields.currentBalance,
        dataCyName: 'account-activity-current-balance',
        whiteSpaceWrap: true,
      },
      {
        size: this.columnSizes[9],
        label:
          'i18n.payments.paymentDashboard.tableHeaders.' +
            HeaderFields.overdueBalance | translate,
        sortField: HeaderFields.overdueBalance,
        dataCyName: 'account-activity-overdue-balance',
        whiteSpaceWrap: true,
      },
    ]"
    [sortField]="sortedField"
    [sortDirection]="sortedDirection"
    (clickEmit)="handleSort($event)"
  ></app-table-header>
</div>

<div class="account-activity-rows">
  <ng-container *ngIf="isDesktop; else isTouch">
    <app-account-activity-row-desktop
      *cdkVirtualFor="let customerMetrics of customersMetrics"
      [customerMetrics]="customerMetrics"
      [columnSizes]="columnSizes"
      [isDsmDashboardOn]="isDsmDashboardOn"
    ></app-account-activity-row-desktop>
  </ng-container>

  <ng-template #isTouch>
    <app-account-activity-row-touch
      *cdkVirtualFor="let customerMetrics of customersMetrics"
      [customerMetrics]="customerMetrics"
      [isDsmDashboardOn]="isDsmDashboardOn"
    ></app-account-activity-row-touch>
  </ng-template>
</div>
